<template>
<div class="chapter">
<div class="inner_page">
<div class="ch1" id="ch1">
<p class="chapterHead"><span class="bold">CHAPTER I</span></p>
<p class="subHead"><span class="bolditalic">The State of Greece from the Earliest Times to the Commencement of the Peloponnesian War</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_ch10.vue?0b605003